import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Select from 'react-select';

function AddDeliveryBoy({ setShowForm, selectedBoy, refreshManagers }) {
  const [loading, setLoading] = useState(false);

  const stateOptions = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
    "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Jammu and Kashmir",
    "Ladakh", "Puducherry", "Chandigarh", "Andaman and Nicobar Islands", "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep"
  ].map(state => ({ value: state, label: state }));

  const [formData, setFormData] = useState({
    id: selectedBoy?.id || null,
    name: selectedBoy?.name || "",
    phone: selectedBoy?.phone || "",
    address: selectedBoy?.address || "",
    state: selectedBoy?.state ? { value: selectedBoy.state, label: selectedBoy.state } : null,
    city: selectedBoy?.city || "",
    area: selectedBoy?.area || "",
    pincode: selectedBoy?.pincode || "",
    aadhar_card: selectedBoy?.aadhar_card || "",
    driving_licence: selectedBoy?.driving_licence || "",
    address_proof: selectedBoy?.address_proof || "",
    profile_image: selectedBoy?.profile_image || "",
    address_proof_url: selectedBoy?.address_proof_url || "",
    profile_url: selectedBoy?.profile_url || "",
    driving_licence_image: selectedBoy?.driving_licence_image || "",
  });

  useEffect(() => {
    if (selectedBoy) {
      setFormData({
        id: selectedBoy.id || null,
        name: selectedBoy.name || "",
        phone: selectedBoy.phone || "",
        address: selectedBoy.address || "",
        state: selectedBoy?.state ? { value: selectedBoy.state, label: selectedBoy.state } : null,
        city: selectedBoy.city || "",
        area: selectedBoy.area || "",
        pincode: selectedBoy.pincode || "",
        aadhar_card: selectedBoy.aadhar_card || "",
        driving_licence: selectedBoy.driving_licence || "",
        address_proof: selectedBoy?.address_proof || "",
        profile_image: selectedBoy?.profile_image || "",
        address_proof_url: selectedBoy.address_proof_url || "",
        profile_url: selectedBoy.profile_url || "",
        driving_licence_image: selectedBoy.driving_licence_image || "",
      });
    }
  }, [selectedBoy]);

  const handleStateChange = selectedOption => {
    setFormData(prev => ({
      ...prev,
      state: selectedOption
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    if (!formData.profile_image && !formData.profile_url) {
      alert("Please upload a profile image.");
      return;
    }

    setLoading(true);

    const formDataToSend = new FormData();
    formDataToSend.append("id", formData.id);
    formDataToSend.append("name", formData.name);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("address", formData.address);
    formDataToSend.append("state", formData.state?.value || "");
    formDataToSend.append("city", formData.city);
    formDataToSend.append("area", formData.area);
    formDataToSend.append("pincode", formData.pincode);
    formDataToSend.append("aadhar_card", formData.aadhar_card);
    formDataToSend.append("driving_licence", formData.driving_licence);
    if (formData.profile_image) formDataToSend.append("profile_image", formData.profile_image);
    if (formData.address_proof) formDataToSend.append("address_proof", formData.address_proof);
    if (formData.driving_licence_image) formDataToSend.append("driving_licence_image", formData.driving_licence_image);

    try {
      const url = formData.id
        ? "https://devapi.bykit.in/api/admin/delivery-boys/update??type=live"
        : "https://devapi.bykit.in/api/admin/delivery-boys/add??type=live";

      const response = await axios.post(url, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status === "RC200") {
        toast.success(formData.id ? "Delivery Boy updated successfully!" : "Delivery Boy added successfully!");
        setFormData({
          id: null,
          name: "",
          phone: "",
          address: "",
          state: null,
          city: "",
          area: "",
          pincode: "",
          aadhar_card: "",
          driving_licence: "",
          address_proof: null,
          profile_image: null,
          driving_licence_image: null,
        });
        refreshManagers();
        setShowForm(false);
      } else {
        toast.error(response.data?.message || "Failed to process request. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='p-3' data-aos="fade-up">
      <ToastContainer />
      <div className='managebrand_box mt-3'>
        <h4 className='dashboard_head py-4 ps-4 m-0'>{formData.id ? "Edit" : "Add"} Delivery Boy</h4>
        <hr className='p-0 m-0' />
        <div className='p-4'>
          <form onSubmit={handleSubmit}>
            <div className="row mt-2">
              <div className="col-md-3">
                <label className="form-label signin_label">Full Name</label>
                <input
                  type='text'
                  name="name"
                  className='form-control'
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-3">
                <label className="form-label signin_label">Phone Number</label>
                <input
                  type='text'
                  name="phone"
                  className='form-control'
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-3">
                <label className="form-label signin_label">Address</label>
                <input
                  type='text'
                  name="address"
                  className='form-control'
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">State</label>
                <Select
                  options={stateOptions}
                  value={formData.state}
                  onChange={handleStateChange}
                  isClearable
                  placeholder="Select State"
                  classNamePrefix="react-select"
                />
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">City</label>
                <input
                  type='text'
                  name="city"
                  className='form-control'
                  value={formData.city}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">Area</label>
                <input
                  type='text'
                  name="area"
                  className='form-control'
                  value={formData.area}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">Pincode</label>
                <input
                  type='text'
                  name="pincode"
                  className='form-control'
                  value={formData.pincode}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">Driving Licence</label>
                <input
                  type='text'
                  name="driving_licence"
                  className='form-control'
                  value={formData.driving_licence}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-3">
                <label className="form-label signin_label">Profile Image</label>
                <input
                  type='file'
                  name="profile_image"
                  className='form-control'
                  onChange={handleInputChange}
                />
                {formData.profile_image && formData.id && (
                  <Link
                    to="#"
                    className="text-decoration-underline"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open('https://devapi.bykit.in/storage/users/'+formData.profile_image, "_blank");
                    }}
                  >
                    View Profile Image
                  </Link>
                )}
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">Aadhar Card Number</label>
                <input
                  type='text'
                  name="aadhar_card"
                  className='form-control'
                  value={formData.aadhar_card}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">Address Proof (Optional)</label>
                <input
                  type='file'
                  name="address_proof"
                  className='form-control'
                  onChange={handleInputChange}
                />
                {formData.address_proof && formData.id && (
                  <Link
                    to="#"
                    className="text-decoration-underline"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open('https://devapi.bykit.in/storage/users/'+formData.address_proof, "_blank");
                    }}
                  >
                    View Address Proof
                  </Link>
                )}
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">Driving licence image</label>
                <input
                  type='file'
                  name="driving_licence_image"
                  className='form-control'
                  onChange={handleInputChange}
                />
                {formData.driving_licence_image && formData.id && (
                  <Link
                    to="#"
                    className="text-decoration-underline"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open('https://devapi.bykit.in/storage/users/'+formData.driving_licence_image, "_blank");
                    }}
                  >
                    View driving licence image
                  </Link>
                )}
              </div>
            </div>

            <div className="d-flex justify-content-end mt-3">
              <button type="submit" className="btn submit_btn" disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddDeliveryBoy;
